import React, {useState} from 'react'
import './homepage.css';
import Logo from '../components/logo/Logo.js';
import Offers from '../components/offers/Offers.js';
import { Box, Container, Paper } from '@mui/material';
import {LoginBtn} from '../components/login-logout-btn/LoginBtn';
import Appbar from '../components/appbar/appbar';
import Flight from '../components/flights/Flight';
import { Outlet } from 'react-router';
import Footerfunc from '../footer/footer';
import Carousel from '../components/carousel/Carousel';

const images = [
  {
    label: 'Efill Tower',
    imgPath:
      'https://th.bing.com/th/id/R.3cca809024079d5a26741fe974026e70?rik=NPLshKmdsZYALA&riu=http%3a%2f%2fmedia.cntraveler.com%2fphotos%2f598339c9b7a86962e8e27c5d%2fmaster%2fpass%2fParis_GettyImages-601763009.jpg&ehk=1sSok1VLsf46Z7UigpsucOVYwAclWQL1zfyCy5qdbiw%3d&risl=&pid=ImgRaw&r=0',
  },
  {
    label: 'Resort',
    imgPath:
      'https://th.bing.com/th/id/OIP.Q6j8ylf-vDw1CfBIVTD-wAAAAA?pid=ImgDet&rs=1',
  },
  {
    label: 'Toursit hub',
    imgPath:
      'https://s2.r29static.com/bin/entry/ed5/0,0,3809,2000/x,80/1718233/image.jpg',
  },
  {
    label: 'Great Oceans',
    imgPath:
      'https://th.bing.com/th/id/OIP.eFQMDMv0cAYmlGeZKwiB4AHaE8?pid=ImgDet&rs=1https://th.bing.com/th/id/OIP.eFQMDMv0cAYmlGeZKwiB4AHaE8?pid=ImgDet&rs=1',
  },
];

const photos =  [
  {
    label: 'Taj',
    imgPath:
      'https://1.bp.blogspot.com/-k9fP923xAEU/UZEzZw9GRpI/AAAAAAAAACw/h5JxFnz6rRQ/s1600/20110103__20110104_D01_FE04STPHOTOG~p1.JPG',
  },
  {
    label: 'Train',
    imgPath:
      'https://www.banfieldtravel.it/wp-content/uploads/2018/10/Scotsman-6.png',
  },
  {
    label: 'Air Plane',
    imgPath:
      'https://th.bing.com/th/id/R.8d3a06b71530a29b8c166f3f5d6c9de0?rik=REH6O3FPXrA%2bug&riu=http%3a%2f%2fwww.pixelstalk.net%2fwp-content%2fuploads%2f2016%2f05%2fPassenger-Airplanes-Wallpaper.jpg&ehk=VF9u96hIwNy00dD2t6kh4QbNP76b0ZtD7LSBaaQBs5E%3d&risl=&pid=ImgRaw&r=0',
  },
  {
    label: 'Tiger',
    imgPath:
      'https://th.bing.com/th/id/R.26167449842007fb4dc52285809aa48a?rik=1so4PbsbXNIzxw&riu=http%3a%2f%2fwwf.worldwildlife.org%2fimages%2fcontent%2fpagebuilder%2f1505indiatigertravel-t.jpg&ehk=ZujA4VJGkIwia%2bTUhPaeL0D1EEROwj%2fo4AgXVrFOknQ%3d&risl=&pid=ImgRaw&r=0',
  }
];

const villas =  [
  {
    label: 'Resort',
    imgPath:
      'https://th.bing.com/th/id/OIP.S1h4pCjp7062EgZaekCagwHaFj?pid=ImgDet&rs=1',
  },
  {
    label: 'Resort2',
    imgPath:
      'https://th.bing.com/th/id/OIP.z1TVmFsnlUvMP9IL0ajeswHaE8?pid=ImgDet&rs=1',
  },
  {
    label: 'Air Services',
    imgPath:
      'https://th.bing.com/th?id=OIF.l%2bkpi5vefhN%2b%2bYOd7b6IHQ&pid=ImgDet&rs=1',
  },
  {
    label: 'Hotels',
    imgPath:
      'https://th.bing.com/th/id/R.ebee8fc692cbcc64c9bfc76459710849?rik=KJQeJhE0ZXTLhA&riu=http%3a%2f%2fwww.cfmedia.vfmleonardo.com%2fimageRepo%2f7%2f0%2f111%2f750%2f197%2fsfolc-exterior-9282-hor-clsc_O.jpg&ehk=h01VKfG19WGTvbV%2b%2bxbzGt4272lxKJ6BnCqyaGRVDX0%3d&risl=1&pid=ImgRaw&r=0',
  },
];
export default function HomePage() {
  
  return (
        <div className='app-body'>
          <Box
          display='flex'
          sx={{justifyContent: 'center', alignItems:'first-baseline', padding:'10px', width:'100%'}}
          className="baseline"
          >
            <Container><Logo /></Container>
            <Offers />
            <Container><LoginBtn /></Container>
          </Box>
          <Appbar />
          <Outlet></Outlet>
          <Paper>
            <Box 
            className="carousel"
            display='flex'
            sx={{justifyContent:'center', alignItems:'center', gap:'50px', margin:'50px', overflowX:'scroll'}}
            >
              <Carousel images={images}/>
              <Carousel images={photos}/>
              <Carousel images={villas} />
            </Box>
          </Paper>
          <Footerfunc />
        </div>
  )
}
